import { loadingMiddleware } from '@gagovictor/shared-frontend-core/dist/shared/redux/loadingMiddleware';
import loadingSlice, {
    LoadingState,
    loadingInitialState,
} from '@gagovictor/shared-frontend-core/dist/shared/redux/loadingSlice';
import refreshSlice, {
    RefreshState,
    refreshInitialState,
} from '@gagovictor/shared-frontend-core/dist/shared/redux/refreshSlice';
import { combineSlices, configureStore } from '@reduxjs/toolkit';

import chatSlice, { chatInitialState, ChatState } from '../chat/redux/chatSlice';
import collectionsSlice, {
    collectionsInitialState,
    CollectionsState,
} from '../collections/redux/collectionsSlice';
import profileSlice, {
    profileInitialState,
    ProfileState,
} from '../profile/redux/profileSlice';
import promptsSlice, {
    promptsInitialState,
    PromptsState,
} from '../prompts/redux/promptsSlice';
import preferencesSlice, {
    PreferencesState,
    preferencesInitialState,
} from '../shared/redux/preferencesSlice';
import usersSlice, {
    usersInitialState,
    UsersState,
} from '../users/redux/usersSlice';
import vectorSpaceSlice, {
    vectorSpaceInitialState,
    VectorSpaceState,
} from '../vectorSpace/redux/vectorSpaceSlice';

// The VictorIA backend has no user accounts, so the core auth, account and
// purchase slices are left out.
export const rootReducer = combineSlices(
    loadingSlice,
    preferencesSlice,
    refreshSlice,
    collectionsSlice,
    profileSlice,
    promptsSlice,
    usersSlice,
    chatSlice,
    vectorSpaceSlice
);

export type RootState = {
    loading: LoadingState;
    preferences: PreferencesState;
    refresh: RefreshState;
    collections: CollectionsState;
    profile: ProfileState;
    prompts: PromptsState;
    users: UsersState;
    chat: ChatState;
    vectorSpace: VectorSpaceState;
};

export const initialState = {
    loading: loadingInitialState,
    preferences: preferencesInitialState,
    refresh: refreshInitialState,
    collections: collectionsInitialState,
    profile: profileInitialState,
    prompts: promptsInitialState,
    users: usersInitialState,
    chat: chatInitialState,
    vectorSpace: vectorSpaceInitialState,
};

export function setupStore(preloadedState?: Partial<RootState>) {
    return configureStore({
        reducer: rootReducer,
        preloadedState,
        middleware: (getDefaultMiddleware) =>
            getDefaultMiddleware({
                // hiddenTopics is a string array and chat messages are plain
                // objects, so only Blob/File payloads on chat thunks need this.
                serializableCheck: {
                    ignoredActionPaths: ['meta.arg'],
                },
            }).concat(loadingMiddleware),
    });
}

export type AppDispatch = typeof store.dispatch;

const store = setupStore(initialState);

export default store;
